var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamicGameAdaptation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.324 175C151.4 171.624 146.82 168.6 142.389 165.377C140.478 163.987 138.857 163.893 136.711 164.866C122.318 171.395 107.57 172.11 92.5323 167.239C91.5843 166.931 91.1353 166.584 91.1503 165.491C91.2201 161.266 91.2001 157.04 91.1602 152.815C91.1502 151.837 91.3448 151.449 92.4624 151.405C99.1579 151.131 104.272 145.883 104.312 139.368C104.352 132.66 99.3026 127.412 92.3826 127.064C91.3498 127.015 91.1502 126.657 91.1602 125.748C91.2001 122.268 91.265 118.777 91.1353 115.301C91.0754 113.737 91.8288 113.727 92.9863 113.732C110.483 113.752 127.98 113.747 145.482 113.747C146.056 113.747 146.64 113.787 147.199 113.707C148.955 113.449 149.893 111.905 149.374 109.958C148.98 108.484 148.825 107.039 149.279 105.584C150.382 102.043 154.029 100.107 157.611 101.125C161.009 102.093 163.049 105.718 162.171 109.228C161.333 112.565 162.271 113.747 165.768 113.752C167.26 113.752 168.752 113.792 170.244 113.737C171.172 113.702 171.416 114.045 171.346 114.944C170.608 124.115 168.088 132.735 163.434 140.709C160.65 145.476 157.312 149.821 153.251 153.57C151.799 154.91 151.469 156.3 151.973 158.158C153.445 163.59 154.802 169.052 156.329 174.995L156.324 175Z",
    fill: "url(#paint0_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.561 55.5966C102.561 64.1619 102.531 72.7272 102.59 81.2926C102.6 82.6531 102.316 83.1546 100.824 83.1447C90.4967 83.0801 80.1691 83.0801 69.8415 83.1447C68.3697 83.1546 68.0454 82.6928 68.0503 81.3075C68.0953 64.7478 68.0953 48.1882 68.0503 31.6286C68.0503 30.3673 68.4744 29.846 69.6369 29.4736C80.0094 26.1567 90.5067 25.5261 101.189 27.7108C102.376 27.9542 102.58 28.4904 102.576 29.558C102.541 38.2375 102.556 46.917 102.556 55.5966H102.561Z",
    fill: "url(#paint1_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8085 88.6418C50.8526 88.6418 55.9016 88.6865 60.9457 88.612C62.2429 88.5922 62.6021 88.9795 62.5821 90.2506C62.5123 95.0423 62.5422 99.8339 62.5572 104.63C62.5672 107.505 63.9791 108.558 66.7331 107.788C69.8414 106.92 72.6254 107.793 74.3766 110.192C76.0679 112.506 76.0978 115.559 74.4564 117.873C72.7351 120.291 69.8913 121.25 66.8579 120.435C63.8344 119.621 62.5223 120.604 62.5073 123.737C62.4874 128.36 62.4524 132.983 62.5273 137.601C62.5522 139.155 62.1331 139.175 60.9207 138.509C44.0723 129.229 33.6349 115.291 29.9279 96.4276C29.5188 94.3521 29.3741 92.2517 29.0997 90.1613C28.9351 88.9149 29.2743 88.5972 30.5017 88.612C35.6056 88.6716 40.7046 88.6369 45.8085 88.6369V88.6418Z",
    fill: "url(#paint2_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.268 29.7373C114.52 31.8774 120.132 34.8964 125.191 38.8836C138.268 49.1818 145.787 62.6282 147.952 79.0637C148.042 79.739 148.027 80.4292 148.087 81.1144C148.266 83.2098 148.266 83.1403 146.211 83.1701C145.128 83.185 144.939 82.7877 144.829 81.7946C144.095 74.8927 139.041 70.1756 132.506 70.1905C126.294 70.2054 120.981 74.9126 120.447 81.0747C120.302 82.7629 119.798 83.2743 118.102 83.18C115.243 83.0261 112.369 83.1254 109.5 83.1452C108.667 83.1502 108.104 83.1005 108.104 81.9933C108.148 64.6987 108.153 47.4042 108.168 30.1097C108.168 30.0551 108.198 30.0005 108.268 29.7373Z",
    fill: "url(#paint3_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5024 57.6875C62.5024 65.5626 62.4675 73.4378 62.5324 81.3129C62.5423 82.7281 62.1482 83.1501 60.7113 83.1402C50.6781 83.0806 40.6448 83.1005 30.6066 83.1203C29.5738 83.1203 28.8903 83.1203 29.015 81.6903C30.3122 66.5954 36.2992 53.7003 47.1856 43.0892C51.182 39.1963 55.6922 35.9787 60.6265 33.362C62.4974 32.3739 62.5024 32.3788 62.5024 34.5735C62.5024 42.2798 62.5024 49.9812 62.5024 57.6875Z",
    fill: "url(#paint4_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.887 70.2197C162.456 70.4134 163.164 70.6368 163.858 70.8901C165.948 71.6597 168.054 72.3896 170.114 73.2337C171.736 73.8941 172.359 75.3589 171.795 76.8386C171.237 78.3084 169.75 79.0433 168.168 78.4921C165.634 77.6083 163.119 76.6648 160.625 75.6717C159.243 75.1206 158.574 74.0083 158.888 72.5286C159.198 71.0589 160.265 70.3687 161.887 70.2197Z",
    fill: "url(#paint5_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31 38.173C142.509 38.2127 141.017 36.3755 141.636 34.5433C142.519 31.9116 143.542 29.3147 144.609 26.7525C145.243 25.2381 146.75 24.6621 148.127 25.1984C149.609 25.7793 150.337 27.2243 149.793 28.8033C148.92 31.3207 147.947 33.8084 147.009 36.301C146.555 37.5027 145.617 38.0439 144.31 38.173Z",
    fill: "url(#paint6_linear_75_348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.747 48.4965C168.787 49.5442 168.158 50.3932 167.106 50.8948C164.736 52.012 162.356 53.1093 159.951 54.1421C158.375 54.8174 156.808 54.2563 156.144 52.9057C155.436 51.4707 156 49.8024 157.596 49.0377C159.956 47.9056 162.346 46.8281 164.771 45.83C166.816 44.9909 168.742 46.2471 168.752 48.4965H168.747Z",
    fill: "url(#paint7_linear_75_348)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_348",
    x1: 131.245,
    y1: 100.854,
    x2: 131.245,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_348",
    x1: 85.3205,
    y1: 26.4316,
    x2: 85.3205,
    y2: 83.1448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_348",
    x1: 52.3638,
    y1: 88.6113,
    x2: 52.3638,
    y2: 138.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_348",
    x1: 128.131,
    y1: 29.7373,
    x2: 128.131,
    y2: 83.1908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_348",
    x1: 45.7665,
    y1: 32.7295,
    x2: 45.7665,
    y2: 83.1404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_348",
    x1: 165.405,
    y1: 70.2197,
    x2: 165.405,
    y2: 78.6751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_348",
    x1: 145.733,
    y1: 25.002,
    x2: 145.733,
    y2: 38.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_348",
    x1: 162.298,
    y1: 45.5684,
    x2: 162.298,
    y2: 54.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 150,
    fill: "white",
    transform: "translate(29 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicGameAdaptation);
export default __webpack_public_path__ + "static/media/Dynamic_Game_Adaptation.9305be759073615d267d510524f8e1fe.svg";
export { ForwardRef as ReactComponent };